// @flow
// ----------------------------------------------------------------------
// <copyright file='Izenda.ReportDetailFooter.js' company='Izenda'>
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import React from 'react';
import connect from 'share/enhancers/Izenda.Connect';

import AuthorizationValidator from 'share/components/hoc/Izenda.AuthorizationValidator';
import AuthorizationConstants from 'logic/data/Izenda.AuthorizationConstants';
import ActionButton from 'share/components/controls/Izenda.ActionButton';
import Button from 'share/components/controls/Izenda.Button';
import ReportButtons from '../Buttons/Izenda.ReportButtons';
import actions from './Izenda.ReportDetailFooterActions';
import localizer from 'share/localization/Izenda.Localizer';
import {ACCESS_RIGHT} from 'logic/data/Izenda.AuthorizationConstants';
import LicenseCheckerConstants from 'logic/data/Izenda.LicenseCheckerConstants';
import uiState from 'logic/Izenda.UiState';
const EmailButton = AuthorizationValidator()(Button);
import { isAnySubscriptionAvailable } from 'share/utils/Izenda.PermissionUtils';

  const SubscribeBtn = AuthorizationValidator()(function(props) {
    return (
      <Button
        label={localizer.getText('COMMON_LABEL_SUBSCRIBE')}
        disabled={!isAnySubscriptionAvailable()}
        {...props} />
    );
  });

  const ExportBtn = AuthorizationValidator()(function(props) {
    return (
      <ReportButtons.ExportReportButton {...props} />
    );
  });

  const DeleteBtn = AuthorizationValidator()(function(props) {
    return (
      <Button label={localizer.getText('COMMON_LABEL_DELETE')} {...props} />
    );
  });

  const MoveBtn = AuthorizationValidator()(function(props) {
    return (
      <Button label={localizer.getText('COMMON_LABEL_MOVE')} {...props} />
    );
  });

  const CopyBtn = AuthorizationValidator()(function(props) {
    return (
      <Button label={localizer.getText('COMMON_LABEL_COPY')} {...props} />
    );
  });

  const PrintBtn = AuthorizationValidator()(function(props) {
    return (
      <ReportButtons.PrintReportButton {...props} />
    );
  });

  const ReportDetailFooter = function(props){
    const {localization, store, authorization} = props;
    const boardDetail = props.boardDetail || {};
    const reportId = boardDetail.id;
    const hasExportingLicense = authorization.checkLicense(LicenseCheckerConstants.LICENSE_KEY.Exporting);
    const hasReportDesginerLicense = authorization.checkLicense(LicenseCheckerConstants.LICENSE_KEY.ReportDesigner);
    const hasScheduleLicense = authorization.checkLicense(LicenseCheckerConstants.LICENSE_KEY.Scheduling);
    const {ReportsActionsEmail, ReportsActionsOverwriteExistingReport} = AuthorizationConstants.PERMISSION_KEY;
    const checkShowMenuRight = authorization.checkPrivileges([ReportsActionsEmail]);
    const hasOverwriteExistingReport = authorization.checkPrivileges([ReportsActionsOverwriteExistingReport]);
    return (
      <div>
        <div className='row'>
          <div className='col-md-12 text-right'>
            <div className='izenda-ActionBar'>
              <ActionButton>
                <Button onClick={props.handleClickOpen} >
                  {localization.getText('COMMON_LABEL_OPEN')}
                </Button>
                {(boardDetail.accessPriority !== ACCESS_RIGHT.Locked &&
                  boardDetail.accessPriority !== ACCESS_RIGHT.ViewOnly &&
                  boardDetail.accessPriority !== ACCESS_RIGHT.NoAccess) &&
                  <div className='btn-group'>
                    <Button
                      className='dropdown-toggle'
                      data-toggle='dropdown'
                      label={localization.getText('COMMON_LABEL_EDIT')}>
                      <span className='caret'></span>
                    </Button>
                    <ul className='dropdown-menu'>
                      {(boardDetail.accessPriority === ACCESS_RIGHT.FullAccess ||
                        boardDetail.accessPriority === ACCESS_RIGHT.QuickEdit ||
                        boardDetail.accessPriority === ACCESS_RIGHT.SaveAs)
                        && <li> <a onClick={props.handleClickQuickEdit}>
                          {localization.getText('REPORT_LABEL_QUICK_EDIT')}
                        </a></li>}
                      {hasReportDesginerLicense
                        && hasOverwriteExistingReport
                        && (
                          boardDetail.accessPriority === ACCESS_RIGHT.FullAccess ||
                          boardDetail.accessPriority === ACCESS_RIGHT.SaveAs)
                        && <li> <a onClick={props.handleClickDesign} >
                          {localization.getText('REPORT_LABEL_DESIGN')}
                        </a></li>}
                      </ul>
                    </div>
                }
                {boardDetail.copyable
                  && (
                    boardDetail.accessPriority === ACCESS_RIGHT.FullAccess ||
                    boardDetail.accessPriority === ACCESS_RIGHT.QuickEdit ||
                    boardDetail.accessPriority === ACCESS_RIGHT.SaveAs)
                  && <CopyBtn
                    onClick={props.handleClickCopy} keys={[
                      AuthorizationConstants.PERMISSION_KEY.ReportsCanCreateNewReportValue]} />}

                {boardDetail.movable &&
                  ((boardDetail.accessPriority === ACCESS_RIGHT.FullAccess && !boardDetail.isGlobal)
                    || (boardDetail.isGlobal && uiState.currentUser.systemAdmin && !uiState.tenantId))
                  && <MoveBtn
                    onClick={props.handleClickMove}
                    keys={[AuthorizationConstants.PERMISSION_KEY.ReportsActionsOverwriteExistingReport]} />}

                {hasExportingLicense && !boardDetail.type
                  && <PrintBtn
                    store={store}
                    print={store.printReport}
                    id={reportId}
                    name={boardDetail.name}
                    keys={[AuthorizationConstants.PERMISSION_KEY.ReportsActionsPrint]} />}

                {!boardDetail.type && hasExportingLicense
                  && <ExportBtn
                    store={store}
                    export={store.exportReport}
                    id={reportId}
                    name={boardDetail.name}
                    keys={[AuthorizationConstants.PERMISSION_KEY.ReportsActionsExporting]}
                    menuRight={!boardDetail.deletable
                      || boardDetail.accessPriority !== ACCESS_RIGHT.FullAccess
                      || !!boardDetail.type
                      || !checkShowMenuRight} />}

                {!boardDetail.type
                  && <EmailButton
                    onClick={props.openEmailPopup}
                    label={localization.getText('COMMON_LABEL_EMAIL')}
                    keys={[AuthorizationConstants.PERMISSION_KEY.ReportsActionsEmail]} />}

                {hasScheduleLicense && !boardDetail.type
                  && <SubscribeBtn
                    onClick={props.handleClickSubscribe}
                    keys={[AuthorizationConstants.PERMISSION_KEY.ReportsActionsSubscribe]} />}

                {boardDetail.deletable
                  && boardDetail.accessPriority === ACCESS_RIGHT.FullAccess
                  && <DeleteBtn
                    onClick={props.deleteReport}
                    keys={[AuthorizationConstants.PERMISSION_KEY.ReportsActionsDel]} />}
              </ActionButton>
            </div>
          </div>
        </div>
      </div>
    );
  };
  export default connect(actions)(ReportDetailFooter);




// WEBPACK FOOTER //
// ./ui/modules/Reports/ReportList/Izenda.ReportDetailFooter.js